module.exports = __webpack_public_path__ + "img/home_chart.d666015.png";